import React from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { setIsOpenDialog } from "../../../redux";
import { HubContextMenu } from "../../../components";
import HubContextMenuItem from "../../../components/HubContextMenu/HubContextMenuItem";

const DELETE = {
  id: "delete",
  label: "Delete",
  icon: "Trash2",
  color: "redError",
};

const SERIALIZATION = {
  id: "serialize",
  label: "Serialize",
  icon: "Barcode",
};

const ContextMenu = ({
  idx,
  hideSerialize = false,
  onDelete = () => {},
  _setIsOpenDialog = () => {},
}) => {
  const onSelect = (item) => {
    switch (item?.id) {
      case "serialize":
        _setIsOpenDialog("work-order-serialization", `${idx}`);
        break;
      case "delete":
        onDelete();
        break;
      default:
        break;
    }
  };

  const onItemSelect = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(item);
  };

  return (
    <HubContextMenu
      id="boxing-menu"
      loading={false}
      HubIconProps={{ size: 11 }}
      MenuProps={{
        sx: {
          "& .MuiButtonBase-root": {
            width: "100%",
            svg: {
              width: "14px !important",
              heiht: "14px !important",
            },
            "& .MuiTypography-root": {
              textAlign: "start",
              fontSize: "12px !important",
            },
          },
        },
      }}
    >
      <Stack alignItems="start">
        {!hideSerialize && (
          <HubContextMenuItem
            key={"serialize"}
            item={SERIALIZATION}
            onSelect={onItemSelect}
          />
        )}
        <HubContextMenuItem
          key={"delete"}
          item={DELETE}
          onSelect={onItemSelect}
        />
      </Stack>
    </HubContextMenu>
  );
};

const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

export const BoxingTableContextMenu = connect(
  () => ({}),
  mapDispatchToProps,
)(ContextMenu);

export default BoxingTableContextMenu;
